import React from 'react'

export default function Loader() {
    return (
        <div className="loading">
            <div className="loader"></div>
        </div>
    )
}
